export default __webpack_public_path__ + "static/centered-partners-29d455b0e703c3c5c5da1fb292380bca.jpg";